<template>
  <Layout2
    title="Set a password"
    padTop="50px"
  >
    <template slot="form">
      <form @submit.prevent="setPassword()">
        <div class="form-floating mb15">
          <input
            type="password"
            id="password"
            placeholder="Create New Password"
            class="form-control fn14"
            name="password"
            v-model="password"
            v-validate="{required:true, regex: $store.state.passwordRegex}"
          />
          <label for="password">Create New Password</label>
          <small class="col_error" v-show="errors.has('password')">{{ errors.first('password') }}</small>
        </div>
        <div class="form-floating mb15">
          <input
            type="password"
            id="confirmPassword"
            placeholder="Re-enter Password to Confirm"
            class="form-control fn14"
            name="confirmPassword"
            v-model="confirmPassword"
            v-validate="{required:true, confirmed: password}"
          />
          <label for="confirmPassword">Re-enter Password to Confirm</label>
          <small class="col_error" v-show="errors.has('confirmPassword')">{{ errors.first('confirmPassword') }}</small>
        </div>
        <div class="mt-4">
          <label class="col_grey75 mb15">Password Strength</label>
          <div class="progress" style="height: 5px;">
            <div class="progress-bar bg_new_green" role="progressbar" :style="{width: `${progress}%`}" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div class="mt15">
            <ul class="m0 p0 ls-none col_grey75">
              <li v-for="(e, i) in rules" :key="i">
                <v-icon :class="[e.value? 'col_new_green': 'col_white']">check</v-icon>
                <span>{{ e.label }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div v-if=!submitted class="form-floating mt30">
          <input type="submit" class="btn btn-apiculus-primary" value="Take me to the cloud" />
        </div>
        <div v-if=submitted class="form-floating mt30">
          <button v-if=submitted class="btn btn-apiculus-primary" type="button">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Take me to the cloud
          </button>
        </div>
        
      </form>
    </template>
  </Layout2>
</template>

<script>
import Layout2 from './Layout2.vue'
import VueCookie from 'vue-cookie'
import VueCookies from 'vue-cookies'
import HTTP from '@/services/http-request-handler'
import helpers from '../../services/toast-service'
import crypto from 'crypto';

export default {
  name: 'SetNewPassword',
  mixins: [helpers],
  data () {
    return {
      password: '',
      minLength: this.$store.state.ApiculusEnv.passwords.minLength,
      maxLength: this.$store.state.ApiculusEnv.passwords.maxLength,
      data: {},
      color: '',
      message: '',
      confirmPassword: '',
      progress: 0,
      submitted: false,
      rules: [
        { label: 'Uppercase character (A-Z)', regex: /(?=.*[A-Z])/gm, value: false },
        { label: 'Lowercase character (a-z)', regex: /(?=.*[a-z])/gm, value: false },
        { label: 'Number (0-9)', regex: /(?=.*[0-9])/gm, value: false },
        { label: 'Special character (!,@,#,$,%,&,*,-)', regex: /(?=.*[!,@,#,$,%,&,*,-])/gm, value: false }
      ],
      publicKey: this.$store.state.ApiculusEnv.publicKey.replace(/ /g, '').replace('BEGINPUBLICKEY', 'BEGIN PUBLIC KEY').replace('ENDPUBLICKEY', 'END PUBLIC KEY'),
      passwordEncryptionOnLogin: this.$store.state.ApiculusEnv.features.passwordEncryptionOnLogin
    }
  },
  created () {
    this.rules.push({ 
      label: this.minLength + ' - ' + this.maxLength + ' characters long',
      regex: new RegExp('^[a-zA-Z0-9,!,@,#,$,%,&,*]{' + this.minLength +',' + this.maxLength +'}$'),
      value: false
    })
  },
  mounted () {
    let userDetails = this.$route.params
    if (!(Object.keys(userDetails).length > 0)) {
      // this.$router.push('/signup')
    } else {
      this.data = userDetails
    }
  },
  components: {
    Layout2
  },
  watch: {
    password () {
      this.rules.map((e, i) => {
        this.rules[i].value = e.regex.test(this.password)
      })
    },
    rules: {
      handler () {
        this.progress = 0
        this.rules.map((e) => {
          if (e.value) {
            this.progress += 20
          }
        })
      },
      deep: true
    }
  },
  methods: {
    setPassword () {
      const encryptedPassword = crypto.publicEncrypt(this.publicKey,
        Buffer.from(this.password, 'utf-8')
      )
      const encryptedConfirmPassword = crypto.publicEncrypt(this.publicKey,
        Buffer.from(this.confirmPassword, 'utf-8')
      )
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$set(this.data, 'password', this.passwordEncryptionOnLogin ? encryptedPassword : this.password)
          this.$set(this.data, 'confirmPassword', this.passwordEncryptionOnLogin ? encryptedConfirmPassword: this.confirmPassword)
          this.submitted = true
          this.$store.dispatch('ACTION_COMPLETE_ACCOUNT_V2', { ...this.data }).then(res => {
            this.submitted = false
            if (!res.success) {
              this.toastAlert(res.error.message || 'Something went wrong.', 'error')
              setTimeout(() => {
                this.$router.push('/signup')
              }, 3000)
            } else {
              this.toastAlert('Account created successfully!', 'success')
              if (res.success && res.result.token) {
                VueCookie.delete('childGroupName')
                VueCookie.delete('parentGroupName')
                VueCookie.delete('userName')
                VueCookie.delete('userRole')
                VueCookie.delete('userID')
                HTTP.defaults.headers['x-access-token'] = res.result.token

                this.$store.state.userDetails= 'getData'
                
                HTTP.get('op_getAccountState').then(response => {
                  VueCookie.set('access-token', res.result.token,{secure: true})
                  VueCookies.set('access-token-key', res.result.token, null,null,null,true,'None')
                  VueCookie.set('currency', res.result.currency,{secure: true})
                  VueCookie.set('last_logged_in', res.result.last_logged_in,{secure: true})
                  VueCookie.set('paymentCurrency', res.result.paymentCurrency,{secure: true})
                  VueCookie.set('account_type', res.result.account_type,{secure: true})
                  VueCookie.set('account_id', response.data.result.ID,{secure: true})
                  if (response.data.result.account_state > 0) {
                    // response.data.result.account_state = 17.02
                    let username = `${response.data.result.first_name} ${response.data.result.last_name}`
                    VueCookie.set('username', username,{secure: true})
                    VueCookie.set('email', response.data.result.email,{secure: true})
                    if (response.data.result.hasOwnProperty('parent_account_id')) {
                      let parentId = response.data.result.parent_account_id
                      VueCookie.set('parentId', parentId,{secure: true})
                    }
                    if (response.data.result.account_state.toString().split('.')[1] === '02') {
                      VueCookie.set('account_state', 'SUSPENDED',{secure: true})
                    } else {
                      VueCookie.set('account_state', response.data.result.account_state,{secure: true})
                    }
                  }

                  if (res.result.account_type == 2) {
                    VueCookie.set('resellerId', res.result.resellerId,{secure: true})
                    VueCookie.set('resellerCode', res.result.resellerCode,{secure: true})
                  }

                  if (res.result.account_type == 12 || res.result.account_type == 11 || res.result.account_type == 2) {
                    window.location.replace('/admin/')
                  } else {
                    window.location.replace('/site/')
                  }
                })
              } else {
                this.$store.state.forEmailVerification = false
                this.$store.state.forAdminApproval = false
                this.$router.push('/')
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
